import { ComponentLoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { getSpacingPixelsString } from "@faire/sdui/lib/deprecated/getSpacingPixels";
import { IComponent } from "@faire/web-api--source/indigofair/data/IComponent";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

// TODO: https://fairewholesale.atlassian.net/browse/FD-217514
// This logic is temporary to allow for horizontal spacing to be set at the component level
// while the backend implementation doesn't exist. The idea is that this fields will be provided by the server
// in the future, and will take precendence over the client values.
// As the backend starts providing these values, this logic should be removed.
export const getFallbackHorizonalSpacingPixels = (
  component: IComponent,
  loggingData: ComponentLoggingEventParams
): ResponsiveValues<string> => {
  if (loggingData.view_display_page === "HOMEPAGE") {
    if (component.header_component !== undefined) {
      return HOMEPAGE_HEADER_HORIZONTAL_SPACING;
    }
    if (
      component.banner_component !== undefined ||
      component.market_banner_component !== undefined
    ) {
      return HOMEPAGE_BANNER_HORIZONTAL_SPACING;
    }
  }
  if (loggingData.view_display_page === "CATEGORY_PAGE") {
    if (loggingData.section_type === "ColumnSection") {
      if (
        component.banner_component !== undefined ||
        component.spacer_component !== undefined ||
        component.carousel_component !== undefined
      ) {
        return { mobileAndAbove: DEFAULT_HORIZONTAL_SPACING };
      }
      return CATEGORY_PAGE_HORIZONTAL_SPACING;
    }

    if (loggingData.section_type === "FilterablePaginatedSection") {
      return { mobileAndAbove: DEFAULT_HORIZONTAL_SPACING };
    }
  }
  return { mobileAndAbove: DEFAULT_HORIZONTAL_SPACING };
};

const HOMEPAGE_BANNER_HORIZONTAL_SPACING: ResponsiveValues<string> = {
  mobileAndAbove: getSpacingPixelsString(Spacing.SPACING_NONE),
  tabletAndAbove: getSpacingPixelsString(Spacing.XXL),
};

const HOMEPAGE_HEADER_HORIZONTAL_SPACING: ResponsiveValues<string> = {
  mobileAndAbove: getSpacingPixelsString(Spacing.SPACING_NONE),
  tabletAndAbove: getSpacingPixelsString(Spacing.SPACING_NONE),
};

const CATEGORY_PAGE_HORIZONTAL_SPACING: ResponsiveValues<string> = {
  mobileAndAbove: getSpacingPixelsString(Spacing.R),
  tabletAndAbove: getSpacingPixelsString(Spacing.XXL),
};

const DEFAULT_HORIZONTAL_SPACING = getSpacingPixelsString(Spacing.SPACING_NONE);
